/** Detect Safari / iOS WebKit where full-screen blur layers jank the landing page. */
export function detectLandingLite(): boolean {
  if (typeof window === 'undefined') return false
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true

  const ua = navigator.userAgent
  const isAppleWebKit =
    (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|EdgiOS|FxiOS|OPR\//.test(ua)) ||
    /iPhone|iPad|iPod/.test(ua)

  return isAppleWebKit
}

let lite = false
const listeners = new Set<() => void>()

export function initLandingLite() {
  lite = detectLandingLite()
  if (lite) {
    document.documentElement.classList.add('landing-lite')
  }
}

export function isLandingLite() {
  return lite
}

export function subscribeLandingLite(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getLandingLiteSnapshot() {
  return lite
}

if (typeof document !== 'undefined') {
  initLandingLite()
}
